import * as React from 'react'

export const styledIcon = (icon, style) => React.cloneElement(icon, { style })
